var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import Input from '../atoms/Input';
import InputLabel from '../atoms/InputLabel';
import ErrorLabel from '../atoms/ErrorLabel';
import _ from 'lodash';
export const SIZES = {
    SMALL: 'small',
    MEDIUM: 'medium',
    LARGE: 'large',
};
const OuterWrapper = styled.div `
    margin-bottom: 20px;
    margin-right: 20px;
    width: 100%;
    max-width: ${props => {
    if (props.size === SIZES.SMALL) {
        return '125px';
    }
    if (props.size === SIZES.MEDIUM) {
        return '190px';
    }
    if (props.size === SIZES.LARGE) {
        return '315px';
    }
    if (props.fullWidth) {
        return 'none';
    }
    return '480px';
}};

    &:last-child {
        margin-bottom: 0;
        margin-right: 0;
    }

    ${props => props.suffix &&
    css `
            position: relative;

            &:after {
                content: '${props.suffix}';
                position: absolute;
                top: 30px;
                right: 15px;
                font-weight: 600;
                font-size: 16px;
                color: ${props => props.theme.primary};
            }
        `}
`;
const StyledInputItem = styled.div `
    position: relative;
    display: flex;
    flex-direction: column;
`;
const IconWrapper = styled.div `
    position: absolute;
    top: 50%;
    left: 15px;
    transform: translateY(-50%);
`;
const FocusBorder = styled.span `
    position: absolute;
    bottom: 0;
    left: 0;
    transform-origin: 0;
    transform: scaleX(0);
    width: 100%;
    height: 1px;
    background-color: ${props => props.theme.secondary};
    transition: all 300ms ease-in-out;
    border-radius: 1px;
`;
const InvonedInputItem = (_a) => {
    var { className, icon, label, error, fullWidth, size, suffix } = _a, props = __rest(_a, ["className", "icon", "label", "error", "fullWidth", "size", "suffix"]);
    const [fid] = useState(() => props.id || _.uniqueId('field-'));
    return (React.createElement(OuterWrapper, { fullWidth: fullWidth, size: size, suffix: suffix, className: className },
        React.createElement(StyledInputItem, null,
            icon && React.createElement(IconWrapper, null, icon),
            React.createElement(InputLabel, { htmlFor: fid, required: props.required }, label),
            React.createElement(Input, Object.assign({}, props, { id: fid })),
            React.createElement(FocusBorder, { className: "focus-border" })),
        error && React.createElement(ErrorLabel, null, error)));
};
export default InvonedInputItem;
